var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[[_c('Sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('div',{class:{ 'fixed-header': _vm.fixedHeader }},[_c('Navbar')],1),_c('AppMain')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }